import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Box, Button } from "@mui/material";
import { BankingSyndicate, Loan } from "@/contexts/DealContext";

type BankingSyndicatesSummaryGridProps = {
  syndicates: BankingSyndicate[];
  loan: Loan;
};

const BankingSyndicatesSummaryGrid: React.FC<BankingSyndicatesSummaryGridProps> = ({
  syndicates,
  loan,
}) => {
  console.log(loan.amount)
  const columns: GridColDef[] = [
    {
      field: "organization",
      headerName: "Organization",
      flex: 1,
      valueFormatter: (params: any) => {
        return params?.name ? params.name : "Unknown";
      },
    },
    {
      field: "commitment",
      headerName: "Commitment",
      flex: 1,
      valueFormatter: (params: any) =>
        `${Number(params).toLocaleString("fr-FR")} ${loan.amount?.currency.value || "EUR"}`,
    },
  ];

  const rows = syndicates.map((s, index) => ({ id: index, ...s }));

  return (
    <Box sx={{ height: "100%", width: "50vw" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        disableDensitySelector
        hideFooter
        density="compact"
        autoHeight
      />
    </Box>
  );
};

export default BankingSyndicatesSummaryGrid;
